import { Box, Typography } from '@mui/material';
import Image from 'next/image';

export const EmptyState = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
      <Image
        src="https://www.nerdwallet.com/cdn/banking/cd-rates/magnifying_glass.svg"
        alt="Empty result"
        width={116}
        height={114}
      />
      <Typography sx={{ fontSize: 24, fontWeight: 350, pb: 3, textAlign: 'center' }}>
        Didn't find what you're looking for?
      </Typography>
      <Typography sx={{ fontWeight: 325, textAlign: 'center', width: { sm: '600px' } }}>
        We couldn't find any results that match your filters. Please try adjusting your criteria and
        search again.
      </Typography>
    </Box>
  );
};
